import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'antd';
import { CloseCircleOutlined, SaveOutlined } from '@ant-design/icons';

function SH_Model(props) {
	const {
		open,
		title,
		onCancel,
		loading,
		handleSubmit,
		children,
		textOk = 'Lưu',
		width,
		heights,
	} = props;

	return (
		<Modal
			open={open}
			title={title}
			centered
			width={width || 1000}
			okButtonProps={{ autoFocus: true }}
			onCancel={onCancel}
			destroyOnHidden
			style={
				heights
					? {
							maxHeight: typeof heights === 'number' ? `${heights}px` : heights,
							overflowY: 'auto',
					  }
					: undefined
			}
			footer={[
				<Button
					icon={<CloseCircleOutlined />}
					key="cancel"
					type="primary"
					danger
					loading={loading}
					onClick={onCancel}
				>
					Hủy
				</Button>,
				<Button
					icon={<SaveOutlined />}
					key="submit"
					type="primary"
					loading={loading}
					onClick={handleSubmit}
				>
					{textOk}
				</Button>,
			]}
		>
			{React.Children.toArray(children)}
		</Modal>
	);
}

SH_Model.propTypes = {
	open: PropTypes.bool,
	title: PropTypes.node,
	onCancel: PropTypes.func,
	loading: PropTypes.bool,
	handleSubmit: PropTypes.func,
	children: PropTypes.node,
	textOk: PropTypes.string,
	width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	heights: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default SH_Model;
